import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { useToast } from "../components/ToastProvider";

export default function Login() {
  const navigate = useNavigate();
  const { login, bootstrap } = useAuth();
  const toast = useToast();

  const [mode, setMode] = useState("login"); // login | bootstrap
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "bootstrap") {
        await bootstrap(form);
        toast.success("Admin account created and signed in.");
      } else {
        await login(form);
        toast.success("Signed in.");
      }
      navigate("/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rs-auth">
      <div className="rs-auth__panel">
        <div className="rs-auth__brand">
          <div className="rs-logo rs-logo--large">
            Royal <span>Shine</span>
          </div>
          <div className="rs-auth__subtitle">Admin Portal</div>
        </div>

        <div className="rs-tabs">
          <button
            className={`rs-tab ${mode === "login" ? "is-active" : ""}`}
            onClick={() => setMode("login")}
            type="button"
          >
            Sign In
          </button>
          <button
            className={`rs-tab ${mode === "bootstrap" ? "is-active" : ""}`}
            onClick={() => setMode("bootstrap")}
            type="button"
          >
            First Time Setup
          </button>
        </div>

        <form className="rs-form" onSubmit={onSubmit}>
          <label className="rs-field">
            <span>Username</span>
            <input
              className="rs-input"
              name="username"
              value={form.username}
              onChange={onChange}
              placeholder="admin@royalshine.com.au"
              autoComplete="username"
              required
            />
          </label>

          <label className="rs-field">
            <span>Password</span>
            <input
              className="rs-input"
              name="password"
              value={form.password}
              onChange={onChange}
              type="password"
              placeholder="••••••••"
              autoComplete={mode === "login" ? "current-password" : "new-password"}
              required
            />
          </label>

          <button className="rs-btn rs-btn--primary" disabled={loading} type="submit">
            {loading
              ? "Please wait..."
              : mode === "bootstrap"
                ? "Create Admin & Sign In"
                : "Sign In"}
          </button>

          <div className="rs-auth__hint">
            {mode === "bootstrap"
              ? "Use this once to create the first admin user."
              : "Sign in with your admin username/password."}
          </div>
        </form>
      </div>
    </div>
  );
}

